import React from "react";
import { Card, CardContent, Paper, Typography } from "@mui/material";
import ResultCard from "./ResultCard";
import useWindowDimensions from "../windowDimensions";

const ResultsPage = ({ content, resultData }) => {
  const { width } = useWindowDimensions();
  const { headline, subheadline, paragraphs, sectionTitle, image } = content;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Paper
        style={{
          width: width * 0.8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "20px 0 20px 0",
        }}
      >
        {(headline || paragraphs) && (
          <Card>
            <CardContent>
              {headline && (
                <Typography
                  variant="h5"
                  component="div"
                  style={{
                    fontFamily: "Impact",
                    fontSize: "2em",
                    textAlign: "center",
                  }}
                >
                  {headline}
                </Typography>
              )}
              {subheadline && (
                <Typography
                  variant="h5"
                  component="div"
                  gutterBottom
                  style={{
                    fontFamily: "Impact",
                    fontSize: "1.25em",
                    textAlign: "center",
                  }}
                >
                  {subheadline}
                </Typography>
              )}
              {paragraphs &&
                paragraphs.map((p, idx) => (
                  <Typography
                    key={idx}
                    variant="h5"
                    component="div"
                    gutterBottom
                    style={{ fontFamily: "Roboto" }}
                    dangerouslySetInnerHTML={{ __html: p }}
                  />
                ))}
            </CardContent>
          </Card>
        )}
        {sectionTitle && <h1>{sectionTitle}</h1>}
        {(resultData || image) && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-around",
            }}
          >
            {resultData &&
              resultData.map((section, idx) => (
                <ResultCard key={idx} card={section} />
              ))}
            {image && (
              <img
                src={image.src}
                alt={image.alt}
                style={{ width: width * image.widthRatio, margin: "0 0 20px 0" }}
              />
            )}
          </div>
        )}
      </Paper>
    </div>
  );
};

export default ResultsPage;
